<script setup lang="ts">
import { ref } from 'vue'
import { currRoute } from './utils'
import { isPageTabbar } from './tabbar/store'
import FgTabbar from '@/tabbar/index.vue'

const isCurrentPageTabbar = ref(true)

// 检查登录状态并跳转
const checkLoginAndRedirect = () => {

  const token = uni.getStorageSync('token')
  const { path } = currRoute()
  // 未登录且不在登录页时，直接跳转登录页
  // if (!token && path !== '/pages/login/index') {
  //   uni.navigateTo({
  //     url: '/pages/login/index',
  //   })
  // }

}

onShow(() => {
  const { path } = currRoute()
  if (path === '/') {
    isCurrentPageTabbar.value = true
  }
  else {
    isCurrentPageTabbar.value = isPageTabbar(path)
  }
  
  // 每次 onShow 时检查登录状态
  checkLoginAndRedirect()
})

const exposeRef = ref('this is form app.Ku.vue')

defineExpose({
  exposeRef,
})
</script>

<template>
  <view>
    <slot />
    <FgTabbar v-if="isCurrentPageTabbar" />
  </view>
</template>

<style lang="scss" scoped>
</style>
